// extracted by mini-css-extract-plugin
export default {"button":"SwapSelectToken_button__R3HXi","logo":"SwapSelectToken_logo__JwaD4","name":"SwapSelectToken_name__74n6j"};